import Vue from 'vue'
import Router from 'vue-router'
import { DOCUMENT_TITLE_PREFIX } from '@/libs/constants'

import SignIn from '@/views/auth/SignIn'

import Member from '@/views/member'
import Dashboard from '@/views/member/dashboard'
import AddUt from '@/views/member/dashboard/add'
import Result from '@/views/member/result'
import Visit from '@/views/member/result/visit'
import Status from '@/views/member/result/status'

import Bridge from '@/views/bridge'
import MyInfo from '@/views/member/myinfo'
import PageNotFound from '@/views/PageNotFound'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: {
        name: 'dashboard'
      }
    },
    {
      path: '/signin',
      name: 'sign-in',
      component: SignIn,
      props: true,
      meta: {
        title: 'Signin',
        layout: 'no-header',
        guestOnly: true
      }
    },
    {
      path: '/go/:utid',
      name: 'bridge',
      component: Bridge,
      props: true,
      meta: {
        layout: 'bridge',
        title: 'Start',
        forAll: true
      }
    },
    {
      path: '/member',
      name: 'member',
      redirect: {
        name: 'dashboard'
      },
      component: Member,
      children: [
        {
          path: '/tool',
          name: 'dashboard',
          component: Dashboard,
          props: true,
          meta: {
            layout: 'dashboard',
            title: 'Dashboard'
          }
        },
        {
          path: '/tool/add',
          name: 'add',
          component: AddUt,
          props: true,
          meta: {
            layout: 'dashboard',
            title: 'Add'
          }
        },
        {
          path: '/tool/edit',
          name: 'edit',
          component: AddUt,
          meta: {
            layout: 'dashboard',
            title: 'Edit'
          }
        },
        {
          path: '/tool/result/preview/:utid',
          name: 'result_preview',
          props: true,
          component: Result,
          meta: {
            layout: 'dashboard',
            title: 'Preview'
          }
        },
        {
          path: '/tool/result/visit/:utid',
          name: 'result_visit',
          props: true,
          component: Visit,
          meta: {
            layout: 'dashboard',
            title: 'visit'
          }
        },
        {
          path: '/tool/result/status/:utid',
          name: 'result_status',
          props: true,
          component: Status,
          meta: {
            layout: 'dashboard',
            title: 'status'
          }
        },
        {
          path: '/tool/myinfo',
          name: 'myinfo',
          component: MyInfo,
          meta: {
            layout: 'myinfo',
            title: 'myinfo'
          }
        }
      ]
    },
    {
      path: '*',
      component: PageNotFound,
      meta: {
        forAll: true,
        title: 'Bad Request'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let title = DOCUMENT_TITLE_PREFIX

  const titleList = to.matched
    .map(item => item.meta.title)
    .filter(item => item !== undefined)
    .reverse()

  let pageTitle

  if (titleList.length) {
    pageTitle = titleList[0]
  }

  if (pageTitle !== null) {
    if (pageTitle) {
      title += ` | ${pageTitle}`
    }
    document.title = title
  }
  next()
})

export default router
